import { render, staticRenderFns } from "./InteractiveMenu.vue?vue&type=template&id=0bad8094&scoped=true"
import script from "./InteractiveMenu.vue?vue&type=script&lang=js"
export * from "./InteractiveMenu.vue?vue&type=script&lang=js"
import style0 from "./InteractiveMenu.vue?vue&type=style&index=0&id=0bad8094&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad8094",
  null
  
)

export default component.exports